'use client';

import useSpinner from '@/hooks/useSpinner';
import Loader from '@/components/filters/Loader';
import { useEffect } from 'react';

// inline carina styles... not ideal but will have to live with this until v2

export function CarinaLoader(): JSX.Element {
  const { showSpinner, showMapLoader } = useSpinner();

  useEffect(() => {
    if (!showSpinner) {
      document.body.style.overflow = '';
    }
  }, [showSpinner]);
  // eslint-disable-next-line no-nested-ternary
  return showSpinner ? (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <div
      role="progressbar"
      className="fixed left-0 top-0 z-[30] flex h-screen w-screen flex-col items-center justify-center bg-[#FFFFFF] opacity-80"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="m-[33px] h-[178px] w-[178px] origin-[50%_50%] animate-rotate-z overflow-visible fill-transparent stroke-[rgb(217,220,222)] stroke-[6px]"
      >
        <defs>
          <linearGradient id="1-gradient" x1="0%" y1="100%" x2="0%" y2="0%">
            <stop offset="0%" stopColor="#00ca9d" />
            <stop offset="50%" stopColor="#4494EF" />
            <stop offset="100%" stopColor="rgb(132,87,217)" />
          </linearGradient>
        </defs>
        <circle cx="50%" cy="50%" r="50%" />
        <circle
          stroke="url(#1-gradient)"
          cx="50%"
          cy="50%"
          r="50%"
          className="custom-stroke origin-[50%_50%] fill-transparent stroke-[6px]"
        />
      </svg>
    </div>
  ) : showMapLoader ? (
    <div className="transform-x-1/2 transform-y-full fixed left-[50%] top-[50%] z-10 h-max w-max transform">
      <Loader className="absolute z-10 h-12 w-12 rounded-[32px] bg-background" spinnerClassName="h-6 w-6" />
    </div>
  ) : (
    <></>
  );
}
